import { createFileRoute } from '@tanstack/react-router';

import { i18n } from '~/utils';
import { buildRouteExport } from '~/utils/buildRouteExport';
import { createProtectedRoute } from '~/utils/routeProtection';
import { getRouteHead } from '~/utils/routeUtils';

import { DeliveryNoteForm } from '~/components/deliveries/deliveryNoteForm/DeliveryNoteForm';

import { routeParams } from './-routeParams';

const title = i18n.t(($) => $.pageTitle.create, { ns: 'delivery' });

export const Route = createFileRoute(
  '/(main)/deliveries/all/create-delivery-note/',
)({
  beforeLoad: createProtectedRoute({
    routePath: '/deliveries/all/create-delivery-note/',
    ...routeParams,
  }),
  component: DeliveryNoteForm,
  head: () => getRouteHead(title),
  staticData: {
    AppBar: {
      title,
    },
  },
});

export const CREATE_DELIVERY_NOTE = buildRouteExport({
  Route,
  ...routeParams,
});
